import { message, notification } from "antd";
import {
  APIResponseStatus,
  ServiceInstanceActions,
} from "../Constants/Constants";
import { convertInstanceFormToApiValues } from "../Helpers/ServiceInstanceHelpers";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Service Instance ${
      action === ServiceInstanceActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ServiceInstanceActions.add ? "adding" : "updating"
  } Service Instance`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const { action, serviceInstanceApi } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history: props.history,
      preProcess: () => setProcessing(false),
      errorCallback: () => message.error(failMessage),
      successCallback: (data) => {
        if (data.status === APIResponseStatus.fail) {
          if (data.info === "ServiceInstance-Name-Duplicated") {
            notification["error"]({
              message: "Error creating Service Instance",
              description: `Service Instance name already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({ redirect: action === ServiceInstanceActions.add });
        }
      },
    });
    try {
      setProcessing(true);
      values.serviceId = props.serviceRecord.serviceId;
      values.instanceId = props.instanceRecord?.instanceId;
      const formattedData = convertInstanceFormToApiValues(
        values,
        props.action
      );
      console.log("onSubmit formattedData", formattedData);
      if (action === ServiceInstanceActions.add) {
        serviceInstanceApi.addServiceInstance(
          formattedData,
          formSubmitCallback
        );
      } else {
        serviceInstanceApi.updateServiceInstance(
          formattedData,
          formSubmitCallback
        );
      }
    } catch (error) {
      message.error(failMessage);
      setProcessing(false);
    }
  };
